import { render, staticRenderFns } from "./KS2Config.vue?vue&type=template&id=66ad5cd4&scoped=true"
import script from "./KS2Config.vue?vue&type=script&lang=js"
export * from "./KS2Config.vue?vue&type=script&lang=js"
import style0 from "./KS2Config.vue?vue&type=style&index=0&id=66ad5cd4&prod&lang=css"
import style1 from "./KS2Config.vue?vue&type=style&index=1&id=66ad5cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad5cd4",
  null
  
)

export default component.exports